import React from "react";
import {observer} from "mobx-react";

import "./images-tab-pane.scss";

import {Kiwis, Station} from "../../../../../kiwis";
import {Icon, Message, Tab} from "semantic-ui-react";

function Placeholder(props: any) {
    return (
        <Tab.Pane
            key={`images-pane-${props.stationId}`}
            className={"images-tab-pane"}
            active={props.active}
        >
            <Message
                className="images-no-data-message"
                icon="eye slash outline"
                header="Keine Daten verfügbar"
                content={props.placeholderText}
            />
        </Tab.Pane>
    );
}

function CarouselIndicator(props: any) {
    return (
        <div className="carousel-indicator">
            {props.items.map((item: any, idx: number) => (
                <div
                    key={idx}
                    className={`circle ${idx === props.currentItemIndex ? "active" : ""}`}
                />
            ))}
        </div>
    );
}

interface ImagesTabPaneProps {
    station: Station;
    kiwis: Kiwis;
    active: boolean; // is tab active
    currentImageIndex: number; // index of visible image
    onImageChange: (index: number) => any;
}

@observer
export class ImagesTabPane extends React.Component<ImagesTabPaneProps, any> {
    constructor(props: ImagesTabPaneProps) {
        super(props);
        this.state = {
            placeholderText: "Für diese Station sind keine Darstellungen verfügbar."
        };
    }

    render() {
        const {kiwis, active, station, currentImageIndex} = this.props;
        if (!active) {
            return null;
        }

        const {placeholderText} = this.state;
        const documents = kiwis.stationDocuments.get(this.props.station.no);
        if (!documents) {
            return <Placeholder
                placeholderText={this.state.placeholderText}
                active={active}
            />;
        }

        const documentData = documents.getDocumentData(kiwis.config.stationImagesConfig, kiwis.config.stationDocumentsBaseUrl);
        if (!documentData.length) {
            return <Placeholder
                placeholderText={placeholderText}
                active={active}
            />;
        }

        const currentImage = documentData[currentImageIndex];

        return (
            <Tab.Pane
                key={`images-pane-${station.id}`}
                className={"images-tab-pane"}
                active={active}
            >
                <div className="outer-container">

                    <div className="inner-container">

                        <div
                            className="arrow-container"
                            onClick={() => this.handleItemClick(true, documentData.length)}
                        >
                            <Icon
                                name="chevron left"
                                size="large"
                            />
                        </div>

                        <div className="image-container">
                            <img
                                src={currentImage.url}
                                alt={currentImage.label}
                            />
                        </div>

                        <div
                            className="arrow-container"
                            onClick={() => this.handleItemClick(false, documentData.length)}
                        >
                            <Icon
                                name="chevron right"
                                size="large"
                            />
                        </div>

                    </div>

                    <CarouselIndicator
                        items={documentData}
                        currentItemIndex={currentImageIndex}
                    />

                    <div className="label">{currentImage.label}</div>

                </div>
            </Tab.Pane>
        );
    }

    handleItemClick(goBackwards: boolean, length: number) {
        if (length < 0) {
            return;
        }

        const {onImageChange, currentImageIndex} = this.props;
        // determine index of next image to show, continuing from the beginning after reaching the end
        let newImageIndex = goBackwards ? currentImageIndex - 1 : currentImageIndex + 1;
        if (newImageIndex >= length) {
            newImageIndex = 0;
        } else if (newImageIndex < 0) {
            newImageIndex = length - 1;
        }
        onImageChange(newImageIndex);
    }
}
